import { authorizedFetch, ErrorResponse } from './api-client';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface TissExtractedProcedure {
  tabela: string;
  tiss_code: string;
  procedure_name: string;
  tooth_region: string;
  tooth_face: string | null;
  qty: string;
  value: string;
}

export interface TissExtractedData {
  parser: string;
  claim_number: string;
  senha: string;
  data_autorizacao: string;
  card_number: string;
  plano: string;
  empresa: string;
  patient_name: string;
  valor_total: string;
  procedures: TissExtractedProcedure[];
  match?: {
    patient_matched: boolean;
    patient_id?: string;
    patient_name?: string;
    clinic_id?: string;
  };
  linked_request_id?: string;
}

export interface TissQueueItem {
  id: string;
  original_filename: string;
  process_status: string;
  result_json: string | null;
  created_at: string;
}

export async function searchTissQueueByClaimNumber(
  claimNumber: string
): Promise<TissQueueItem | null> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/telegram/search?claim_number=${encodeURIComponent(claimNumber)}`
  );

  if (response.status === 404) return null;

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao buscar guia');
  }

  return response.json();
}

export async function fetchLinkedGuides(
  requestId: string
): Promise<TissQueueItem[]> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/telegram/linked/${requestId}`
  );

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao carregar guias vinculadas');
  }

  return response.json();
}

export async function linkTissQueueToRequest(
  queueId: string,
  requestId: string
): Promise<void> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/telegram/${queueId}/link`,
    {
      method: 'POST',
      body: JSON.stringify({ request_id: requestId }),
    }
  );

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao vincular guia');
  }
}

export async function unlinkTissQueueFromRequest(
  queueId: string
): Promise<void> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/telegram/${queueId}/unlink`,
    { method: 'POST' }
  );

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao desvincular guia');
  }
}
